import * as React from "react";
import { GetGameIdentityForGoal } from "source/app/presentation/MainPanel/GameIdentities/Helpers/GetGameIdentityForGoal";
import { ShowIdentityDetails } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/Details/ShowIdentityDetails";
import { ILogState } from "source/app/presentation/MainPanel/Log/ILogState";
import { GetGoalNamesLoggedToday } from "source/app/presentation/MainPanel/Log/GetGoalNamesLoggedToday";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { StyleClass } from "../../../../../Shared/Styles/CSS";

export function ShowLinkToIdentityScore({ goalId }: { goalId: number }) {
    const gameIdentity = GetGameIdentityForGoal(goalId);

    if (!gameIdentity) {
        return null;
    }

    const logEntries = State.ReadClass<ILogState>(ESharedComponent.Log).state
        .logData;

    const goalNamesLoggedToday = GetGoalNamesLoggedToday(logEntries);

    return (
        <IconWithText
            iconSuffix={EGlyphicon["arrow-right"]}
            whenClicked={() =>
                ShowIdentityDetails(gameIdentity, goalNamesLoggedToday)
            }
            displayAsBlock
            withClass={StyleClass(`ShowLinkToIdentityScore`, {
                opacity: 0.4,
                margin: `4px`,
            })}
        >
            show combo components
        </IconWithText>
    );
}
